import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/home-bg.png'
import _imports_1 from '@/assets/icon/home2.png'
import _imports_2 from '@/assets/icon/home1.png'


const _withScopeId = n => (_pushScopeId("data-v-e2080d80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = {
  key: 0,
  class: "home-bg",
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  autoplay: "",
  muted: "",
  loop: "",
  preload: "auto",
  id: "myVideo",
  "webkit-playsinline": "",
  playsInline: "",
  "x5-playsinline": "",
  "t7-video-player-type": "inline",
  "x5-video-player-type": "h5-page",
  "x-webkit-airplay": "allow",
  disablePictureInPicture: ""
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "https://video.feifanbio-tech.com/video/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91%E5%A4%84%E7%90%86%E7%89%88.mp4",
  type: "video/mp4"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "txt-img",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn",
    href: "https://www.feifanbio-tech.com/index.php/%e5%b9%b3%e5%8f%b0%e4%bb%8b%e7%bb%8d/",
    rel: "noopener",
    target: "_parent"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text" }, "探索我们"),
    /*#__PURE__*/_createElementVNode("img", {
      class: "btn-icon",
      src: _imports_2,
      mode: ""
    })
  ])
], -1))

import { closeDialog } from "vant";
import { onMounted, onUnmounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isWechat = ref(false)
onMounted(()=>{
 isWeChatMobileBrowser()
})
function isWeChatMobileBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /mobile/i.test(userAgent);
    const isWeChat = /micromessenger/i.test(userAgent);
    if (isMobile && isWeChat) {
        const weChatVersionMatch = userAgent.match(/micromessenger\/([\d.]+)/);
        if (weChatVersionMatch) {
            const weChatVersion = weChatVersionMatch[1];
            console.log(`当前微信版本号为: ${weChatVersion}`);
        }
        isWechat.value = true
        return true;
    }
    isWechat.value = false
    return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isWechat.value)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("video", _hoisted_3, _hoisted_5)),
    _hoisted_6
  ]))
}
}

})